"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _gatsbyTransformUrl = require("@imgix/gatsby-transform-url");

var _decodeUriComponent = _interopRequireDefault(require("decode-uri-component"));

var _limitedWidth = require("../../hoc/limitedWidth.constants");

var _helper = _interopRequireDefault(require("./helper"));

var _options = _interopRequireDefault(require("./options"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      Img = _ref.Img;

  var Image = /*#__PURE__*/function (_React$Component) {
    _inherits(Image, _React$Component);

    var _super = _createSuper(Image);

    function Image(props) {
      _classCallCheck(this, Image);

      return _super.call(this, props);
    }

    _createClass(Image, [{
      key: "readSrcParams",
      value: function readSrcParams() {
        return _helper["default"].readSrcParams(this.props.src, ['w', 'h', 'fm']);
      }
    }, {
      key: "render",
      value: function render() {
        var fluid = (0, _gatsbyTransformUrl.buildFluidImageData)((0, _decodeUriComponent["default"])(this.rawSrc), _objectSpread(_objectSpread({}, this.imgixParams), {}, {
          auto: ['format', 'compress'] // recommended for all images

        }), {
          includeLibraryParam: false,
          sizes: this.sizes // optional, but highly recommended

        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.imageClasses
        }, /*#__PURE__*/_react["default"].createElement(Img, {
          fluid: fluid,
          backgroundColor: this.props.placeholder
        }));
      }
    }, {
      key: "sizes",
      get: function get() {
        var mobileWidth = _limitedWidth.maxWidth;
        var desktopWidth = _limitedWidth.maxWidthDesktop;

        if (this.props.size === _options["default"].size.answer) {
          mobileWidth = _limitedWidth.maxWidthAnswer;
          desktopWidth = _limitedWidth.maxWidthDesktopAnswer;
        }

        return "(max-width: ".concat(_limitedWidth.desktopBreakpoint - 1, "px) ").concat(mobileWidth, "px, ").concat(desktopWidth, "px");
      }
    }, {
      key: "rawSrc",
      get: function get() {
        return _helper["default"].rawSrc(this.props.src);
      }
    }, {
      key: "ratio",
      get: function get() {
        return _helper["default"].ratio(this.props.size);
      }
    }, {
      key: "imageClasses",
      get: function get() {
        var _cn;

        var _this$props = this.props,
            theme = _this$props.theme,
            borderRadius = _this$props.borderRadius,
            framed = _this$props.framed,
            preventDesktopBehaviour = _this$props.preventDesktopBehaviour;
        return (0, _classnames["default"])(theme.imageIx, theme.imageContainer, (_cn = {}, _defineProperty(_cn, theme.preventDesktop, preventDesktopBehaviour), _defineProperty(_cn, theme.framed, framed), _defineProperty(_cn, theme.minorRoundedCorners, borderRadius === 'minor'), _defineProperty(_cn, theme.majorRoundedCorners, borderRadius === 'major'), _cn));
      }
    }, {
      key: "imgixParams",
      get: function get() {
        return _objectSpread(_objectSpread({}, this.readSrcParams()), {}, {
          ar: this.ratio,
          fit: 'crop',
          q: 80
        });
      }
    }]);

    return Image;
  }(_react["default"].Component);

  Image.displayName = identifier;
  Image.themeShape = {
    imageIx: _propTypes["default"].string.isRequired,
    small: _propTypes["default"].string.isRequired,
    medium: _propTypes["default"].string.isRequired,
    large: _propTypes["default"].string.isRequired,
    imageContainer: _propTypes["default"].string.isRequired,
    imagePlaceholder: _propTypes["default"].string.isRequired,
    imageHd: _propTypes["default"].string.isRequired,
    imageHdLoaded: _propTypes["default"].string.isRequired,
    imageHdFadeIn: _propTypes["default"].string.isRequired,
    preventDesktop: _propTypes["default"].string.isRequired,
    minorRoundedCorners: _propTypes["default"].string.isRequired,
    majorRoundedCorners: _propTypes["default"].string.isRequired
  };
  Image.propTypes = {
    size: _propTypes["default"].oneOf(Object.values(_options["default"].size)),
    src: _propTypes["default"].string.isRequired,
    placeholder: _propTypes["default"].string.isRequired,
    // style related
    className: _propTypes["default"].string,
    theme: _propTypes["default"].shape(Image.themeShape).isRequired,
    preventDesktopBehaviour: _propTypes["default"].bool,
    framed: _propTypes["default"].bool,
    borderRadius: _propTypes["default"].oneOf(['minor', 'major']).isRequired
  };
  Image.defaultProps = {
    size: 'medium',
    placeholder: '',
    preventDesktopBehaviour: false,
    framed: false,
    borderRadius: 'minor'
  };
  return Image;
};

var _default = factory;
exports["default"] = _default;